import script from "./SwapRoute.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwapRoute.vue?vue&type=script&setup=true&lang=ts"

import "./SwapRoute.vue?vue&type=style&index=0&id=2727fcd4&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2727fcd4"]])

export default __exports__